export const useEnergyCost = (certificate) => {
    var _a, _b;
    const minMaxEstimation = (_a = certificate.features) === null || _a === void 0 ? void 0 : _a.find((feature) => feature.type === "minMaxEstimation");
    const estimationDescription = (_b = certificate.features) === null || _b === void 0 ? void 0 : _b.find((feature) => feature.type === "estimationDescription");
    return {
        estimationLabel: minMaxEstimation === null || minMaxEstimation === void 0 ? void 0 : minMaxEstimation.label,
        estimationValue: minMaxEstimation === null || minMaxEstimation === void 0 ? void 0 : minMaxEstimation.value,
        estimationDescription: estimationDescription === null || estimationDescription === void 0 ? void 0 : estimationDescription.value,
    };
};
